export class ExportTypeConstants {
    static PDF = "pdf";
    static XLSX = "xlsx";
    static DOCX = "docx";
}
